<div class="app-background" aria-hidden="true">
  <div class="bg-glow g1"></div>
  <div class="bg-glow g2"></div>
</div>

<nw-global-header *ngIf="showHeader"></nw-global-header>
<router-outlet></router-outlet>
